export default "__VITE_ASSET__PIphbCA5__"